
import { EventBus } from '@/plugins/eventBus'
import axios from 'axios'
import Vue from 'vue'
import { VueConstructor } from 'vue/types/umd'

export default (Vue as VueConstructor<Vue>).extend({
  name: "CardFormatter",
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    redirectToSplit: {
      // when true, the card will emit a redirectToSplit event
      // when false, the card will open a new tab with the worker's page
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      previewUrls: {} as { [key: string]: string },
      activePreviewId: null as number | null,
      hideTimeout: null as number | null,
      imageTypes: {} as { [key: string]: boolean },
      unsupportedFormat: {} as { [key: string]: boolean },
      dialog: false,
      titleModal: "alerts_details",
      data: null,
      major: true,
    }
  },
  methods: {
    openTo(email: string, type: string): void {
      if (email) {
        globalThis.location.href = `${type}:${email}`
      }
    },
    openData(titleModal: string, data: any, major = true) {
      this.dialog = true
      this.major = major
      this.data = data
      this.titleModal = titleModal
    },
    checkLogo(name: string): string {
      switch (name) {
        case 'bike_scooter':
          return 'bike'
        case 'mass_transit':
          return 'bus'
        case 'carpool':
          return 'car-2-plus'
        default:
          return name
      }
    },
    isMajor(date: string | undefined) {
      if (typeof date === 'undefined') {
        return true
      }
      return (Date.now() - new Date(date).getTime()) / 1000/60/60/24/365.25 >= 18
    },
    checkAlerts(alerts: Array<string>|undefined) {
      return alerts === undefined || alerts.length === 0
    },
    handleNamesClick() {
      this.redirectToSplit ? this.$emit('redirectToSplit', this.item.id) : globalThis.open(`/workers/update/${this.item.id}`, '_blank')
    },
    async showPreview(cvUrl: string, workerId: number) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }

      if (cvUrl && !this.previewUrls[cvUrl]) {
        try {
          const result = await this.fetchDocument(cvUrl)
          this.previewUrls[cvUrl] = result.url
          this.imageTypes[cvUrl] = result.isImage
        } catch (error) {
          console.error('Error fetching document:', error)
        }
      }

      this.activePreviewId = workerId
    },
    startHidePreview() {
      this.hideTimeout = globalThis.setTimeout(this.hidePreview, 100)
    },
    cancelHidePreview() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
    },
    hidePreview() {
      this.activePreviewId = null
    },
    async fetchDocument(url: string): Promise<{ url: string; isImage: boolean }> {
      try {
        const token = localStorage.getItem('token')
        const response = await axios.get(url, {
          responseType: 'blob',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': '*/*'
          }
        })

        const contentDisposition = response.headers['content-disposition']
        if (!contentDisposition) {
          return { url: '', isImage: false }
        }

        const extension = this.getFileExtension(contentDisposition)
        const { mimeType, isImage } = this.getMimeTypeFromExtension(extension)

        if (!mimeType) {
          this.unsupportedFormat[url] = true
          return { url: '', isImage: false }
        }

        const blob = new Blob([response.data], { type: mimeType })
        return {
          url: URL.createObjectURL(blob),
          isImage
        }
      } catch (error) {
        console.error('Error fetching document:', error)
        EventBus.$emit('snackbar', { axiosError: error })
        return { url: '', isImage: false }
      }
    },
    getFileExtension(contentDisposition: string): string {
      const filename = contentDisposition.split('filename="')[1]?.split('"')[0]
      if (!filename?.includes('.')) return ''
      return filename.split('.').pop()?.toLowerCase() || ''
    },
    getMimeTypeFromExtension(extension: string): { mimeType: string; isImage: boolean } {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif']

      if (imageExtensions.includes(extension)) {
        const imageType = extension === 'jpg' ? 'jpeg' : extension
        return { mimeType: `image/${imageType}`, isImage: true }
      }

      if (extension === 'pdf') {
        return { mimeType: 'application/pdf', isImage: false }
      }

      return { mimeType: '', isImage: false }
    },
  }   
})
